import { SiteCoreDictionary } from './types';

const fallbackDictionary: SiteCoreDictionary = {
    blockAreYouSureBlock: 'Ja, sperr kortet',
    blockError: 'Noe gikk galt under sperring av kort. Vennligst prøv igjen senere.',
    blockStatusSoft: 'Kortet er sperret midlertidig',
    formBackToCards: 'Tilbake til kortoversikt',
    formOk: 'Ok',
    formCancel: 'Avbryt',
    loadingSoftBlockingCard: 'Sperrer kortet midlertidig...',
    confirmBySmsText: 'Bekreftelse blir sendt på SMS til mobilnummer',
    messageErrorUps: 'Ojsann!',
    orderBankCardFailureText: 'Noe gikk feil, vent litt og prøv igjen.',
    softBlockConfirm: 'Bekreft midlertidig sperring av kort',
    softBlockConfirmInformation: 'Du har valgt å midlertidig sperre kort med kortnummer',
    blockConfirmToAccountNumber: 'til kontonummer',
};

export default fallbackDictionary;
